<template>
  <b-container>
    <b-row>
      <b-col />
      <b-col>
        <ValidationObserver
          ref="observer"
          v-slot="{ invalid }"
          class="tsny_form"
        >
          <logo-full />
          <b-row>
            <b-col>
              <BTextInputValidated
                rules="required|email"
                type="email"
                label="Email"
                name="Email"
                v-model="email"
                @keyup.enter.native="requestPasswordReset"
              />
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-button
              v-if="showResetButton"
              class="tsny_button"
              :disabled="invalid"
              @click="requestPasswordReset()"
              >RESET PASSWORD</b-button
            >
            <p v-if="resetSuccess" class="tsny_status-text">
              An email has been sent to {{ email }} containing a link to reset
              your password. You will be redirected back to the login screen in
              {{ redirectCount }} seconds
            </p>
            <p v-if="resetError" class="tsny_status-text">
              There was an issue generating your password reset email. Please
              try again in a few minutes
            </p>
          </b-row>
        </ValidationObserver>
      </b-col>
      <b-col />
    </b-row>
  </b-container>
</template>

<script>
import ExternalRestService from "../../services/rest/services/ExternalRestService";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../../components/FormInputs/BTextInputValidated";

export default {
  name: "RequestPasswordReset",
  components: { ValidationObserver, BTextInputValidated },
  data: function() {
    return {
      email: null,
      redirectCount: 10,
      showResetButton: true,
      resetSuccess: false,
      resetError: false,
      token: null
    };
  },
  methods: {
    navigateToResetPage: function() {
      this.$router.push({
        name: "ResetPassword",
        params: { token: this.token }
      });
    },

    requestPasswordReset: async function() {
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.resetError = false;

      return ExternalRestService.requestPasswordReset({
        email: $comp.email
      })
        .then(() => {
          $comp.showResetButton = false;
          $comp.resetSuccess = true;
          $comp.resetError = false;

          (function countdown() {
            setTimeout(() => {
              $comp.redirectCount--;
              if ($comp.redirectCount > 0) {
                countdown();
              } else {
                $comp.$router.push("/login");
              }
            }, 1000);
          })();
        })
        .catch(error => {
          console.log(error);
          $comp.resetError = true;
        });
    }
  }
};
</script>
